import React, { useEffect, useState } from "react";
import "./LegalReference.scss";
import { useTranslation } from "react-i18next";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "us.helper/types";
import { EditLegalReference } from "./components";
import { $Skeleton } from "us.common/components";

const LegalReference: React.FC<PropsFromRedux> = (props) => {
  const { t } = useTranslation();
  const [isDrawerVisible, setIsDrawerVisible] = useState<boolean>(false);

  const { accountSummeryWidgetData, legalReference } = props;
  const { case: caseDetails } = accountSummeryWidgetData.data ?? {};
  const { referenceNo } = caseDetails ?? {};

  useEffect(() => {
    if (legalReference.isSaved && !legalReference.isSaving) {
      setIsDrawerVisible(false);
    }
  }, [legalReference]);

  return (
    <>
      <div
        className="legal-reference legal-reference-clickable mx-2"
        onClick={() => setIsDrawerVisible(true)}
        data-testid="legal-reference-view"
      >
        <div className="reference-pic legal-reference-icon">
          <img alt="" />
        </div>
        <div className="legal-reference-details">
          <$Skeleton
            active
            loading={accountSummeryWidgetData.isLoading}
            paragraph={false}
          >
            <span
              className="legal-reference-number"
              data-testid="legal-reference-number"
            >
              {referenceNo ||
                t("US.COLLECTION.CASE:LEGAL_REFERENCE.NOT_AVAILABLE")}
            </span>
          </$Skeleton>
          <span className="legal-reference-type">
            {t("US.COLLECTION.CASE:LEGAL_REFERENCE.LEGAL_REFERENCE_NUMBER")}
          </span>
        </div>
      </div>

      <EditLegalReference
        visible={isDrawerVisible}
        onClose={() => setIsDrawerVisible(false)}
      />
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  const { dashboard, domainView } = state;
  const { accountSummeryWidgetData } = dashboard;
  const { metaData, legalReference } = domainView;
  return {
    accountSummeryWidgetData,
    caseNo: state.case.caseNo,
    metaData,
    legalReference,
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(LegalReference);
